import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-users",
  templateUrl: "./med-icon-users.component.html",
})
export class MedIconUsersComponent extends SvgMixinComponent {}
